import React from 'react'
import { useField } from 'formik'
import { FieldWrapper } from './FieldWrapper'
import clsx from 'clsx'
import { InputDefaults } from './form-defaults'


function FormikTextInput({ className, name, label, helpText, errorClassName, unstyled = false, rows = 4, placeholder = '', ariaLabel, wrapped = true, disabled = false, readOnly = false }: {
  className?: string,
  rows?: number,
} & InputDefaults<string>) {
  const [field, meta] = useField(name)
  const error = meta.touched && meta.error ? meta.error : undefined;

  return (
    <FieldWrapper
      name={name}
      label={label}
      helpText={helpText}
      error={error}
      errorClassName={errorClassName}
      wrapped={wrapped}
    >
      <textarea
        {...field}
        rows={rows}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        aria-label={ariaLabel}
        aria-invalid={!!error}
        className={clsx(
          !unstyled && "w-full bg-background px-4 py-2 rounded-xl border shadow-lg focus:ring-3 text-sm",
          !unstyled && "focus:ring-primary",
          (!!disabled || !!readOnly) && "bg-muted",
          className,
          error && "border-danger"
        )}
      />
    </FieldWrapper>
  )
}


export default FormikTextInput;
